 
import { getID } from "src/libs/utilities";
import { LANDING_TYPE_CONTENT } from "../interfaces";

export default function canvas(): any[] {
    return [
        { 
            "id": getID("canvas"), 
            "type": LANDING_TYPE_CONTENT.CANVAS, 
            "height": "450px" ,
            defaultTitle: "Чистый холст"
        }
    ]
}